import { z } from "zod";
export const PagerSchema = z.object({
    more: z.object({
        text: z.string(),
        action: z.object({
            type: z.string(),
            url: z.string(),
        }),
    }),
});
//# sourceMappingURL=index.js.map